    import { Component, Injector, OnInit } from '@angular/core';
    import { ActivatedRoute, Router } from '@angular/router';
    import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
    import { AppComponentBase } from '@shared/common/app-component-base';
    import { appModuleAnimation } from '@shared/animations/routerTransition';
    import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
    import {
    KnowledgeBankServiceProxy,
    GetKnowledgeBankForViewDto,
    MediaLibraryServiceProxy,
    MediaLibraryModel,
    ContactUsServiceProxy,
    GetContactUsForHomeViewDto
    } from '@shared/service-proxies/service-proxies';

    @Component({
        templateUrl: './view-knowledge-base-public.component.html',
        styleUrls: ['./view-knowledge-base-public.component.scss'],
        animations: [appModuleAnimation()],
    })
    export class ViewKnowledgeBasePublicComponent extends AppComponentBase implements OnInit {
        active = false;
        saving = false;

        item: GetKnowledgeBankForViewDto;
        attachmentsList: MediaLibraryModel[] = [];

        returnUrl = '/knowledge-base';
        returnLinkResource = 'KnowledgeBase';

        creationTimeJsDate: Date | null = null;

    // Related items slider
    relatedItems: GetKnowledgeBankForViewDto[] = [];
    relatedItemsPerSlide = 4;
    relatedCurrentSlide = 0;

        categories = [
            { label: 'اللوائح (Regulations)', value: 1 },
            { label: 'القوانين (Laws)', value: 2 },
            { label: 'الأدلة الإرشادية (Guidelines)', value: 3 }
        ];

        breadcrumbs: BreadcrumbItem[] = [
            new BreadcrumbItem(this.l(this.returnLinkResource), this.returnUrl),
            new BreadcrumbItem(this.l('View')),
        ];

    viewContactUs: GetContactUsForHomeViewDto = new GetContactUsForHomeViewDto();

        constructor(
            injector: Injector,
            private _activatedRoute: ActivatedRoute,
            private _knowledgeBankService: KnowledgeBankServiceProxy,
            private _mediaLibraryProxy: MediaLibraryServiceProxy,
            private _router: Router,
        private _sanitizer: DomSanitizer,
        private _contactusServiceProxy: ContactUsServiceProxy
        ) {
            super(injector);
            this.item = new GetKnowledgeBankForViewDto();
        }

        getCategoryLabel(categoryId: number | undefined): string {
            if (!categoryId) return '';
            const cat = this.categories.find(c => c.value === categoryId);
            return cat ? cat.label : '';
        }

        ngOnInit(): void {
            this.show(this._activatedRoute.snapshot.params['id']);
        this.loadContactUs();
        }

    loadContactUs(): void {
        this._contactusServiceProxy.getPublished().subscribe((contactusResult) => {
        this.viewContactUs = contactusResult;
        });
    }

    private loadRelatedItems(): void {
        const category = this.item?.knowledgeBank?.category;
        if (!category) {
        this.relatedItems = [];
        return;
        }

        this._knowledgeBankService
        .getAllPublished('', category, 'creationTime DESC', 0, 20)
        .subscribe((result) => {
            const currentId = this.item?.knowledgeBank?.id;
            this.relatedItems = (result.items || []).filter(
            (x) => x.knowledgeBank && x.knowledgeBank.id !== currentId
            );
            this.relatedCurrentSlide = 0;
        });
    }

    get relatedTotalSlides(): number {
        if (!this.relatedItems || this.relatedItems.length === 0) {
        return 0;
        }
        return Math.ceil(this.relatedItems.length / this.relatedItemsPerSlide);
    }

    get visibleRelatedItems(): GetKnowledgeBankForViewDto[] {
        const start = this.relatedCurrentSlide * this.relatedItemsPerSlide;
        const end = start + this.relatedItemsPerSlide;
        return this.relatedItems.slice(start, end);
    }

    goToRelatedSlide(index: number): void {
        if (index < 0 || index >= this.relatedTotalSlides) {
        return;
        }
        this.relatedCurrentSlide = index;
    }

    prevRelatedSlide(): void {
        if (this.relatedCurrentSlide > 0) {
        this.relatedCurrentSlide--;
        }
    }

    nextRelatedSlide(): void {
        if (this.relatedCurrentSlide < this.relatedTotalSlides - 1) {
        this.relatedCurrentSlide++;
        }
    }

    viewDetails(id: number | undefined): void {
        if (!id) {
        return;
        }
        this._router.navigate(['/knowledge-base/view', id]);
    }

    truncateTwoSentences(html: string | undefined, fallbackChars: number = 77): string {
        if (!html) return '';

        const div = document.createElement('div');
        div.innerHTML = html;

        const text = (div.textContent || div.innerText || '')
        .replace(/\s+/g, ' ')
        .trim();

        if (!text) return '';

        const sentences = text.match(/[^.!؟!]+[.!؟!]+|[^.!؟!]+$/g) || [];

        if (sentences.length > 2) {
        return sentences.slice(0, 2).join(' ').trim() + '...';
        }

        if (text.length > fallbackChars) {
        return text.slice(0, fallbackChars).trim() + '...';
        }

        return text;
    }

    private afterItemLoaded(): void {
        this.loadRelatedItems();
    }

        show(id: number): void {
            this._knowledgeBankService.getPublished(+id).subscribe(
                (result) => {
                    this.item = result;

                    const ct: any = this.item?.knowledgeBank?.creationTime;
                    this.creationTimeJsDate = ct?.toJSDate ? ct.toJSDate() : (ct ? new Date(ct) : null);

                    if (this.item?.knowledgeBank?.attachmnets) {
                        this.loadMedia(this.item.knowledgeBank.attachmnets);
                    }

                    this.active = true;
                    this.afterItemLoaded();
                },
                () => {
                    this._router.navigate([this.returnUrl]);
                }
            );
        }

        loadMedia(tokenString: string): void {
            const tokens = tokenString.split(',').filter(t => !!t);
            this.attachmentsList = [];
            tokens.forEach(token => {
                this._mediaLibraryProxy.getMediaForAnonymous(token).subscribe((result) => {
                    this.attachmentsList.push(result);
                });
            });
        }

        get hasAttachment(): boolean {
            return !!this.item?.knowledgeBank?.attachmnets;
        }

        print(): void {
            window.print();
        }

        downloadAttachment(attachment: MediaLibraryModel): void {
            const link = document.createElement('a');
            link.href = attachment.fileContent;
            link.download = attachment.fileName;
            link.click();
        }

        close(): void {
            this._router.navigate([this.returnUrl]);
        }
    }

